import { render } from "./About.vue?vue&type=template&id=a36af7ea"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=a36af7ea&lang=scss"

import exportComponent from "/codebuild/output/src703991735/src/Jessy-Rent-O-/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__